import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import { searchState } from '../../recoil/state/search'
import { DatePicker } from 'mailup-web-components'
import { DATE_PICKER_FORMAT } from 'Constants'

export const InputFilterFrom = ({ onChange }) => {
  const intl = useIntl()
  const [{ filterByFieldTo, filterByFieldFrom }, setSearch] = useRecoilState(
    searchState
  )

  const { current: currentDate } = useRef(new Date())

  const handleChange = value => {
    setSearch(prev => {
      onChange(value)
      return { ...prev, filterByFieldFrom: value }
    })
  }

  return (
    <DatePicker
      name='filterByFieldFrom'
      value={filterByFieldFrom}
      callback={handleChange}
      isClearable={false}
      locale={intl.locale}
      dateFormat={DATE_PICKER_FORMAT}
      showTimeSelect
      autocomplete='new-filterByFieldFrom'
      maxDate={filterByFieldTo || currentDate}
      data-mu-test='filterbyfield-from'
    />
  )
}

InputFilterFrom.propTypes = {
  onChange: PropTypes.func
}
